import p from '../../styles/Profile.module.css';
import BackHome from "../../components/BackHome";

function Tv() {
    const steps = [
        { text: 'Для Android TV / Fire TV скачайте v2rayNG из Google Play или установите через APK', href: 'https://play.google.com/store/apps/details?id=com.v2ray.ang' },
        { text: 'Для Apple TV установите приложение FoXray или Sing-box из App Store', href: null },
        { text: 'Скопируйте ссылку на подписку на телефоне или компьютере', href: null },
        { text: 'Перенесите ссылку на ТВ (через QR-код в приложении или функцию Send Files to TV)', href: null },
        { text: 'Добавьте ссылку в раздел подписок вашего ТВ-клиента и активируйте подключение', href: null },
    ];

    return (
        <>
            <BackHome />
            <div className={p.page}>
                <div className={p.section}>
                    <p className={p.section_title} style={{ cursor: 'default' }}>
                        Инструкция по настройке Android TV / Apple TV
                    </p>
                    
                    <div className={p.steps}>
                        {steps.map((step, i) => (
                            <div className={p.step_row} key={i}>
                                <div className={p.step_num}>{i + 1}</div>
                                <p className={p.step_text}>
                                    {step.href ? (
                                        <a href={step.href} className={p.step_link} target="_blank" rel="noreferrer">
                                            {step.text}
                                        </a>
                                    ) : (
                                        step.text
                                    )}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
}

export default Tv;